import React from "react";

const AnimatedLoader = () => {
  return (
    <div className="background-gradient fixed h-screen w-screen flex items-center justify-center">
      <img src="/init.gif" className="w-36" />
    </div>
  );
};

export default AnimatedLoader;
